/** @format */

import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "../../router/protected-route";
import PublicRoute from "../../router/public-route";
import PublicViewRoute from "../../router/public-view-route";
import { ProtectedRouter } from "../../configs/routes.config/user-protected-route";
import { AuthRouter } from "../../configs/routes.config/auth-route";
import { PublicRouter } from "../../configs/routes.config/public-route";
import { EmpProtectedRouter } from "../../configs/routes.config/employer-protected-route";
import appConfig from "../../configs/app.config";

const { authenticatedAdminEntryPath } = appConfig;

//NOT USIGN THIS PAGE

const AllRoutes = () => {
  return (
    <Routes>
      <Route
        path="*"
        element={<Navigate replace to={authenticatedAdminEntryPath} />}
      />

      {/* USER ROUTES */}
      <Route element={<ProtectedRoute />}>
        {ProtectedRouter.map((route) => (
          <Route
            key={route.key}
            path={route.path}
            element={
              <Suspense fallback={<div>Loading...</div>}>
                {route.element}
              </Suspense>
            }
          />
        ))}
      </Route>
      <Route element={<PublicRoute />}>
        {AuthRouter.map((route) => (
          <Route
            key={route.key}
            path={route.path}
            element={
              <Suspense fallback={<div>Loading...</div>}>
                {route.element}
              </Suspense>
            }
          />
        ))}
      </Route>
      <Route element={<PublicViewRoute />}>
        {PublicRouter.map((route) => (
          <Route
            key={route.key}
            path={route.path}
            element={
              <Suspense fallback={<div>Loading...</div>}>
                {route.element}
              </Suspense>
            }
          />
        ))}
      </Route>

      {/* EMPLOYER ROUTES */}
      <Route element={<ProtectedRoute />}>
        {EmpProtectedRouter.map((route) => (
          <Route
            key={route.key}
            path={route.path}
            element={
              <Suspense fallback={<div>Loading...</div>}>
                {route.element}
              </Suspense>
            }
          />
        ))}
      </Route>
      <Route element={<PublicRoute />}>
        {AuthRouter.map((route) => (
          <Route
            key={route.key}
            path={route.path}
            element={
              <Suspense fallback={<div>Loading...</div>}>
                {route.element}
              </Suspense>
            }
          />
        ))}
      </Route>
      <Route element={<PublicViewRoute />}>
        {PublicRouter.map((route) => (
          <Route
            key={route.key}
            path={route.path}
            element={
              <Suspense fallback={<div>Loading...</div>}>
                {route.element}
              </Suspense>
            }
          />
        ))}
      </Route>
    </Routes>
  );
};
const Views = (props) => {
  return <AllRoutes {...props} />;
};

export default Views;
